<template>
  <el-row style="margin: 1.25rem;">
    <div v-if="liad_show">
      <load></load>
    </div>
    <el-row v-for="(item,index) in list" :key="index">
      <el-row style="margin-top: 1.875rem;"v-if="item.type=='radio'">
        <el-col :offset="2" :span="20" style="background-color: white; padding: 1.875rem;">
          <span style="font-size: 12px;color: #707070;">[单选题]</span>
          <span>{{item.name}}
          <span style="font-size: 12px;color: #707070;">
            (共{{item.num_count}}人填写)
          </span>
          </span>
          <div :id="'radio'+index" class="char"></div>
          <span></span>
          <!-- <el-button  @click="tuli(item.choice)">图 例</el-button> -->
          <el-button style="float: right;" @click="show_all(item.choice)">显示详情</el-button>
        </el-col>
      </el-row>

      <el-row style="margin-top: 1.875rem;" v-if="item.type=='checkbox'">
        <el-col :offset="2" :span="20" style="background-color: white; padding: 1.875rem;">
          <span style="font-size: 12px;color: #707070;">[多选题]</span>
          <span>{{item.name}}
          <span style="font-size: 12px;color: #707070;">
            (共{{item.num_count}}人填写)
          </span></span>

          <div :id="'checkbox'+index" class="char"></div>
          <el-button  @click="tuli(item.choice)">图 例</el-button>
          <el-button style="float: right;" @click="show_all(item.choice)">显示详情</el-button>
        </el-col>
      </el-row>

      <el-row style="margin-top: 1.875rem;" v-if="item.type=='input'">
          <el-col :offset="2" :span="20" style="background-color: white; padding: 1.875rem;">
            <span style="font-size: 12px;color: #707070;">[填空题]</span>
            <span>{{item.name}}
            <span style="font-size: 12px;color: #707070;">
              (共{{item.num_count}}人填写)
            </span>
            </span>
             <el-table
             height="300"
             :data="item.choice"
             style="width: 100%;overflow: auto;">
             <el-table-column
               label="序号"
               align="center"
               type="index"
               :index="indexAdd"
               width="50"/>
              </el-table-column>
                <el-table-column
                  prop="user"
                  label="用户答案">
                </el-table-column>
              </el-table>
            <!-- <el-button style="float: right;margin-top: 0.625rem;" @click="show_all_input(item.choice)">显示详情</el-button> -->
          </el-col>
      </el-row>
    </el-row>

    <el-dialog
      title="详细信息"
      :visible.sync="dialog.show"
      width="60%">
      <el-table
      class="over"
         :data="dialog.list"
         :style='{height:dialog_height}'>
         <el-table-column
           prop="name"
           label="选项">
         </el-table-column>
         <el-table-column
           prop="value"
           label="个数"
           width="100">
         </el-table-column>
         <el-table-column
           prop="percentage"
           label="百分数"
           width="100">
         </el-table-column>

       </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog.show = false">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="详细信息"
      :visible.sync="dialog.input_show"
      width="60%">
      <el-table
       :style='{height:dialog_height}'
       class="over"
         :data="dialog.input_list"
        >
         <el-table-column
           prop="user"
           label="选项">
         </el-table-column>
       </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog.input_show = false">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="图例"
      :visible.sync="dialog.tuli_show"
      width="60%">
      <el-table
      class="over"
         :data="dialog.tuli_list"
         :style='{height:dialog_height}'>
         <el-table-column
           prop="type"
           width="100"
           label="X轴">
         </el-table-column>
         <el-table-column
           prop="name"
           label="内容"
           >
         </el-table-column>
       </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog.tuli_show = false">关 闭</el-button>
      </span>
    </el-dialog>

  </el-row>
</template>

<script>
   import load from "../../../../components/load.vue"
  const echarts = require('echarts/lib/echarts');
  require('echarts/lib/component/title');
  require('echarts/lib/component/tooltip');
  require('echarts/lib/component/legend');
  require('echarts/lib/chart/pie');
  require('echarts/lib/component/grid');
  require('echarts/lib/chart/bar');
  require('echarts/lib/chart/line');
  export default {
    data() {
      return {
        X:['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'],
        data:{},
        dialog_height:'',
        input_height:'',
        liad_show:false,
        dialog:{
          show:false,
          list:[],
          input_show:false,
          input_list:[],
          tuli_show:false,
          tuli_list:[]
        },
        list:[],
        num:this.$route.query.num,
        char_list:{},
        // char_binghzuang:{},
        // char_zhuzhuang:{},
        // char_zhexian:{},
        // char_kjshiyong:{},
        colors1: [
          '#3682be',
          '#334f65',
          '#0c84c6',
          '#ffa510',
          '#ffbd66',
          '#f74d4d',
          '#41b7ac'
        ],
      }
    },
    components: {
       load:load
    },
    mounted () {
      this.get_info()
      this.dialog_height=document.documentElement.clientHeight * 0.5+'px'
      // this.char_radio()
      // this.char_checkbox()
    },

    methods: {
      indexAdd(index) {
        return index + 1
      },
      tuli(item){
        this.dialog.tuli_show=true
        this.dialog.tuli_list=item
      },
      show_all_input(item){
        this.dialog.input_show=true
        this.dialog.input_list=item
      },
      show_all(item){
        this.dialog.show=true
        this.dialog.list=item
      },
      get_info(){
        let _this=this
        _this.liad_show=true
        _this.axios.get("/v2/c_investigate/investigate_push_per",{params: {
          num:_this.num
        }}).then(function (res) {
          if (res.status == "200") {
            if(res.data.code=='1'){
               _this.data=res.data.data
               _this.set_data()
            }else{
              _this.$message.error(res.data.data.msg)
              _this.liad_show=false
            }
          } else {
            _this.liad_show=false
            _this.$message.error("服务器内部错误")
          }
        })
      },
      set_data(){
        let _this=this
        for(let i=0;i<_this.data.length;i++){
          if(_this.data[i].type=='input'){
            let data=[]
            for(let q=0;q< _this.data[i].num.length;q++){

              let list={
                user:_this.data[i].num[q]
              }
              data.push(list)
            }
            _this.data[i]['choice']=data
          }else{
            for(let j=0;j<_this.data[i].choice.length;j++){
              if(_this.data[i].num.hasOwnProperty(j)){
                _this.data[i].choice[j]['value']=_this.data[i].num[j]
                _this.data[i].choice[j]['percentage']=(_this.data[i].choice[j]['value']/_this.data[i].num_count )*100+'%'
              }else{
                _this.data[i].choice[j]['value']='0'
                _this.data[i].choice[j]['percentage']='0%'
              }
              _this.data[i].choice[j]['type']=_this.X[j]

            }
          }
          _this.list=_this.data
          setTimeout(() => {
           for(let i=0;i<_this.list.length;i++){
             if(_this.list[i].type=='radio'){
               _this.char_radio(_this.list[i].choice,'radio'+i)
             }else if(_this.list[i].type=='checkbox'){
               let X=[]
               let Y=[]
               for(let j=0;j<_this.list[i].choice.length;j++){
                Y.push(_this.list[i].choice[j].value)
                X.push(_this.list[i].choice[j].type)
               }
               _this.list[i].choice['X']=X
               _this.list[i].choice['Y']=Y
               _this.char_checkbox(_this.list[i].choice,'checkbox'+i)
             }
           }
           _this.liad_show=false
          },1000)

        }
      },
      char_checkbox(data,type){
        let _this = this;
        // let X=['选项A', '选项B', '选项C', '选项D']
        // let Y=[2, 2, 1, 10]
        var chartDom = document.getElementById(type);
        _this.char_list.char_checkbox = echarts.init(chartDom);
        var option;
        option = {
          color: _this.colors1,
          xAxis: {
            type: 'category',
            name: '选项',
            boundaryGap: false,
            data:data.X,
            axisLabel: {
              color: '#333',
              //  让x轴文字方向为竖向
              interval: 0,
              rotate: -40
            }
          },
          yAxis: {
            type: 'value',
            name: '个数',
            axisLine:{
              show:false
            }
          },
          series: [{
            data: data.Y,
            type: 'line',
            areaStyle: {},
            itemStyle : { normal: {label : {show: true}}},
          }]
        };
        option && _this.char_list.char_checkbox.setOption(option);
        _this.char_end('char_checkbox')
      },
      char_radio(data,type) {
        let _this = this;
        var chartDom = document.getElementById(type);
        _this.char_list.char_radio = echarts.init(chartDom);
        var option = {
          color: _this.colors1,
          tooltip: {
            trigger: 'item'
          },
          legend: {
            width: '100%',
            left: 'center'
          },
          series: [{
            name:data.name ,
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '14',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: data
          }]
        }
        option && _this.char_list.char_radio.setOption(option);
        _this.char_end('char_radio')
      },
      char_end(type){
        let _this=this
        setTimeout(function() {
          window.onresize = function() {
            _this.char_list.type.resize();
          }
        }, 200)
    },
    }
  }
</script>

<style scoped>
  .char {
    width: 100%;
    min-height: 250px;
  }
  .over{
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/view/company/questionnaire/quest_data/details.vue